<section>
    <p-tabMenu [model]="menuItems" [activeItem]="menuItems[1]"></p-tabMenu>
</section>
<section>
    <div class="container-fluid">
        <ol class="breadcrumb">
            <li class="breadcrumb-item">Home</li>
            <li class="breadcrumb-item">Reports</li>
            <li class="breadcrumb-item active">Emails Sent to Anonymous Users</li>
        </ol>
    </div>
</section>
<section>
    <div class="container-fluid">
        <div class="row mb-2">
            <div class="col-sm-12 p-0">
                <div class="card Title-bar-blue">
                    <div class="devcare-card-header">
                        <span class="devcare-sub-header Title-bar-text"><img src="../../../../assets/img/report.png"> Email Delivery Report</span>
                        <div class="float-right">
                            <button pButton (click)="clear(dt2)" label="Clear" class="p-button-raised" icon="pi pi-trash" 
                            style="height: 30px;background-color: aliceblue;color: #1a90d0;"></button>
                        </div>                       
                        &nbsp;&nbsp;
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<section>
    <form [formGroup]="emailDeliveryReportForm" novalidate>
    <div class="card">  
        <div class="card-body">
            <div class="row">
                <div class="col-md-12">
                    <div class="col-md-12">
                        <div class="p-fluid p-formgrid p-grid">
                                <div style="margin-left: auto; margin-right: auto; width: 25%;">
                                    <label for="startDate">Start Date<span class="required-field">*</span></label>
                                    <p-calendar class="invreportdatepicker" [showIcon]="true" inputId="navigators" formControlName="startDate" (onSelect)="onSelectStartDate($event)" [monthNavigator]="true" [yearNavigator]="true"  yearRange="2000:2030"></p-calendar>                          
                                </div>
                                <div style="margin-left: auto; margin-right: auto; width: 25%;">
                                    <label for="endDate">End Date<span class="required-field">*</span></label>
                                    <p-calendar class="invreportdatepicker" [showIcon]="true" inputId="navigators" formControlName="endDate" [minDate]="startDateSelectedDate" [monthNavigator]="true" [yearNavigator]="true"  yearRange="2000:2030"></p-calendar>                          
                                </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="card-footer">
          <div class="text-center">
            <button class="bg-success" pButton pRipple type="button" [disabled]="!this.emailDeliveryReportForm.valid"
                (click)="generateEmailDeliveryReport(emailDeliveryReportForm,dt2)"
                style="background-color: #1a90d0; color: white;font-weight: bold;"><img src="../../../../assets/img/New-rep.png"
                    width="32px">Get Report</button>
          </div>
        </div>
        <br><br><br>
    </div>
    <br>
    <br>
</form>
</section>
<section>
    <div [hidden]="!showTable" class="card">
        <div class="card-header">
           <span class="text-lg font-weight-bold">Email Delivery Report - Emails Sent to Anonymous Users</span>
           <div class="card-tools">
            <button pButton label="Clear" class="p-button-raised m-2" icon="pi pi-filter-slash"
            (click)="clearFilter(dt2)" style="float: left;height: 30px;"></button>
            <button pButton label="Export" class="p-button-raised  m-2" *ngIf="sharedService.checkPermission('Admin_Export')" (click)="exportAnonymousEmailMessageReport()"
            icon="pi pi-file-excel" type="button" style="height: 30px;"></button>
            <p-multiSelect [options]="allColumns" [(ngModel)]="selectedColumns" maxSelectedLabels="0" dropdownIcon="pi pi-list" selectedItemsLabel="{0} columns selected" optionLabel="header"  [showHeader] = "false">
                <ng-template let-column pTemplate="item">
                    <div class="column-item">
                        <div>{{column.header}}</div>
                    </div>
                </ng-template>
            </p-multiSelect>
            
        </div>
        </div>
        <div class="card-body" id="page-admin">
            <p-table #dt2 [value]="emailDeliveryReportList" [lazy]="true"
                (onLazyLoad)="loadEmailDeliveryReportList($event)" paginatorDropdownAppendTo="body" dataKey="vendorCompanyName" [rows]="10"
                [showCurrentPageReport]="true" [resizableColumns]="true" columnResizeMode="expand"
                [rowsPerPageOptions]="[10,25,50,100,250,500,1000]" styleClass="p-datatable-gridlines"  [scrollable]="true" scrollHeight="350px"  [responsive]="true"
                [paginator]="isshowpaginator" [totalRecords]="totalRecords"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries">
                <ng-template pTemplate="colgroup" let-columns>
                    <colgroup [attr.colspan]="selectedColumns.length">
                        <col style="width: 3rem;">
                        <col style="width: 20rem" *ngIf="isShowColumns('emailTemplateName')">
                        <col style="width: 20rem" *ngIf="isShowColumns('emailSubject')">
                        <col style="width: 7rem" *ngIf="isShowColumns('emailSentDate')">
                        <!-- <col style="width: 9rem" *ngIf="isShowColumns('vendorName')"> -->
                        <col style="width: 9rem" *ngIf="isShowColumns('emailSentTo')">
                        <!-- <col style="width: 8rem" *ngIf="isShowColumns('userName')"> -->
                        <col style="width: 9rem;" *ngIf="isShowColumns('startDate')">
                        <col style="width: 9rem;" *ngIf="isShowColumns('endDate')">       
       
                    </colgroup>
                </ng-template>
                <ng-template pTemplate="header">
                    <tr>
                        <th *ngIf="isShowColumns('#')" style="background-color: #1a90d0;color: rgb(255 255 255);width: 3rem;" pResizableColumn>#</th>
                        <th *ngIf="isShowColumns('emailTemplateName')" 
                            style="background-color: #1a90d0;color: rgb(255 255 255);width: 20rem;" pResizableColumn>Email Name 
                            <span pSortableColumn="emailTemplateName" style="background-color: #1a90d0;color: rgb(255 255 255);">
                                <p-sortIcon field="emailTemplateName" style="border-style:none !important"></p-sortIcon>
                            </span>
                                <app-basic-filter [field]="'emailTemplateName'" [filters]="filters" [table]="table"
                                (applyFilter)="applyFilterNew()">
                            </app-basic-filter>
                            </th>
                        <th *ngIf="isShowColumns('emailSubject')" 
                            style="background-color: #1a90d0;color: rgb(255 255 255);width: 20rem;" pResizableColumn>Email Subject 
                            <span pSortableColumn="emailSubject" style="background-color: #1a90d0;color: rgb(255 255 255);">
                                <p-sortIcon field="emailSubject" style="border-style:none !important"></p-sortIcon>
                            </span>
                                <app-basic-filter [field]="'emailSubject'" [filters]="filters" [table]="table"
                                (applyFilter)="applyFilterNew()"></app-basic-filter>
                            </th>
                            <th *ngIf="isShowColumns('emailSentDate')" 
                            style="background-color: #1a90d0;color: rgb(255 255 255);width: 7rem;" pResizableColumn>Email Sent<br>Date
                            <span pSortableColumn="emailSentDate" style="background-color: #1a90d0;color: rgb(255 255 255);">
                                <p-sortIcon field="emailSentDate" style="border-style:none !important"></p-sortIcon>
                            </span>
                            <app-date-filter [field]="'emailSentDate'" [filters]="filters" [table]="table"
                            (filterDate)="emailSentDateFilterData($event)"
                            [filterData]="emailSentDateFilterValue"></app-date-filter>
                        </th>
                            <!-- <th *ngIf="isShowColumns('vendorName')" 
                            style="background-color: #1a90d0;color: rgb(255 255 255);width: 9rem;" pResizableColumn>Company 
                            <span pSortableColumn="vendorName" style="background-color: #1a90d0;color: rgb(255 255 255);">
                                <p-sortIcon field="vendorName" style="border-style:none !important"></p-sortIcon>
                            </span>
                                <app-basic-filter [field]="'vendorName'" [filters]="filters" [table]="table"
                                (applyFilter)="applyFilterNew()"></app-basic-filter>
                            </th> -->
                            <th *ngIf="isShowColumns('emailSentTo')" 
                            style="background-color: #1a90d0;color: rgb(255 255 255);width: 9rem;" pResizableColumn>Sent To 
                            <span pSortableColumn="emailSentTo" style="background-color: #1a90d0;color: rgb(255 255 255);">
                                <p-sortIcon field="emailSentTo" style="border-style:none !important"></p-sortIcon>
                            </span>
                                <app-basic-filter [field]="'emailSentTo'" [filters]="filters" [table]="table"
                                (applyFilter)="applyFilterNew()"></app-basic-filter>
                            </th>
                            <!-- <th *ngIf="isShowColumns('userName')" 
                            style="background-color: #1a90d0;color: rgb(255 255 255);width: 8rem;" pResizableColumn>User 
                            <span pSortableColumn="userName" style="background-color: #1a90d0;color: rgb(255 255 255);">
                                <p-sortIcon field="userName" style="border-style:none !important"></p-sortIcon>
                            </span>
                                <app-basic-filter [field]="'userName'" [filters]="filters" [table]="table"
                                (applyFilter)="applyFilterNew()"></app-basic-filter>
                            </th> -->
                           
                        <th *ngIf="isShowColumns('startDate')" 
                            style="background-color: #1a90d0;color: rgb(255 255 255);width: 9rem;" pResizableColumn>Start Date
                            <span pSortableColumn="startDate" style="background-color: #1a90d0;color: rgb(255 255 255);">
                                <p-sortIcon field="startDate" style="border-style:none !important"></p-sortIcon>
                            </span>
                            <app-date-filter [field]="'startDate'" [filters]="filters" [table]="table"
                            (filterDate)="startDateFilterData($event)"
                            [filterData]="startDateFilterValue"></app-date-filter>
                        </th>
                        <th *ngIf="isShowColumns('endDate')" 
                            style="background-color: #1a90d0;color: rgb(255 255 255);width: 9rem;" pResizableColumn>End Date
                            <span pSortableColumn="endDate" style="background-color: #1a90d0;color: rgb(255 255 255);">
                                <p-sortIcon field="endDate" style="border-style:none !important"></p-sortIcon>
                            </span>
                            <app-date-filter [field]="'endDate'" [filters]="filters" [table]="table"
                            (filterDate)="endDateFilterData($event)"
                            [filterData]="endDateFilterValue"></app-date-filter>
                        </th>
                    </tr>
                    <tr>
                        <th *ngIf="isShowColumns('#')"></th>
                        <th *ngIf="isShowColumns('emailTemplateName')">{{filters?.emailTemplateName[0]?.value}}</th>
                        <th *ngIf="isShowColumns('emailSubject')">{{filters?.emailSubject[0]?.value}}</th>
                        <th *ngIf="isShowColumns('emailSentDate')">
                            <div *ngIf="emailSentDateFilterValue != undefined">
                                {{emailSentDateFilterValue[0]?.valueControl| date:'MM/dd/yyyy'}} <span *ngIf="emailSentDateFilterValue.length > 1">-</span> {{emailSentDateFilterValue[1]?.valueControl | date:'MM/dd/yyyy'}}
                            </div>
                        </th>                        
                        <!-- <th *ngIf="isShowColumns('vendorName')">{{filters?.vendorName[0]?.value}}</th> -->
                        <th *ngIf="isShowColumns('emailSentTo')">{{filters?.emailSentTo[0]?.value}}</th>
                        <!-- <th *ngIf="isShowColumns('userName')">{{filters?.userName[0]?.value}}</th> -->
                        <th *ngIf="isShowColumns('startDate')">
                            <div *ngIf="startDateFilterValue != undefined">
                                {{startDateFilterValue[0]?.valueControl| date:'MM/dd/yyyy'}} <span *ngIf="startDateFilterValue.length > 1">-</span> {{startDateFilterValue[1]?.valueControl | date:'MM/dd/yyyy'}}
                            </div>
                        </th>                            
                        <th *ngIf="isShowColumns('endDate')">
                                <div *ngIf="endDateFilterValue != undefined">
                                    {{endDateFilterValue[0]?.valueControl| date:'MM/dd/yyyy'}} <span *ngIf="endDateFilterValue.length > 1">-</span> {{endDateFilterValue[1]?.valueControl | date:'MM/dd/yyyy'}}
                                </div>
                            </th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-emailDeliveryReportList let-rowIndex="rowIndex">
                    <tr>
                        <td style = "width: 3rem" *ngIf="isShowColumns('#')">{{rowIndex + 1}}</td>
                        <td style = "width: 20rem" *ngIf="isShowColumns('emailTemplateName')">{{emailDeliveryReportList.emailTemplateName}}</td>
                        <td style = "width: 20rem" *ngIf="isShowColumns('emailSubject')">{{emailDeliveryReportList.emailSubject}}</td>
                        <td style = "width: 7rem" *ngIf="isShowColumns('emailSentDate')">{{emailDeliveryReportList.emailSentDate | date:'MM/dd/yyyy'}}</td>
                        <!-- <td style = "width: 9rem" *ngIf="isShowColumns('vendorName')">{{emailDeliveryReportList.vendorName}}</td> -->
                        <td style = "width: 9rem" *ngIf="isShowColumns('emailSentTo')">{{emailDeliveryReportList.emailSentTo}}</td>
                        <!-- <td style = "width: 8rem" *ngIf="isShowColumns('userName')">{{emailDeliveryReportList.userName}}</td> -->
                        <td style = "width: 9rem" *ngIf="isShowColumns('startDate')">{{emailDeliveryReportList.startDate | date:'MM/dd/yyyy'}}</td>
                        <td style = "width: 9rem" *ngIf="isShowColumns('endDate')">{{emailDeliveryReportList.endDate | date:'MM/dd/yyyy'}}</td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                    <tr>
                      <td [attr.colspan]="selectedColumns.length">No email delivery report found.</td>
                    </tr>
                  </ng-template>
            </p-table>
        </div>      
    </div>
    <!-- <br><br><br><br> -->
</section>
